/**
 * @desc 保存
 */
import { MemberGroupEntity } from '@eastcoal/api/auth/interface'
import { apiFetch } from '@eastcoal/common/utils/fetcher/api'
import {
  RequestOptions,
  ApiConfig
} from '@eastcoal/common/utils/fetcher/interface'

export type CreateMemberGroupParameter = MemberGroupEntity

const method = 'POST'
const url = '/auth/group'

export const createMemberGroupApi = (
  data?: CreateMemberGroupParameter,
  config?: Partial<RequestOptions<ApiConfig>>
) => {
  return apiFetch<MemberGroupEntity>({
    method,
    url,
    data,
    ...config
  })
}

createMemberGroupApi.method = method
createMemberGroupApi.url = url
